export default [
  {
    id: 70662,
    name: "Stencil Art Online",
    img: "/images/gm_stencil_art_online.jpg",
    url: "https://html5.gamemonetize.com/86xb3i8eqe6vwy7gygpec0enu60zl3ot/",
    description:
      "Are you the next graffiti master? Stencil Art will come true to your painting dream! Just spray, it is super easy. There are lots of pictures waiting for you, take a spray can and press jet. Then you will see a cute picture! Watch ads you could get cool colors. Show us your pieces!",
    category: ["Puzzles"],
    tag: [
      "2d",
      "boys",
      "color",
      "coloring",
      "food",
      "girls",
      "h5",
      "hot",
      "html",
      "html5",
      "hypercasual",
      "kids",
      "mobile",
      "online",
      "relaxation",
    ],
    control_info: "Press the mouse and drag",
  },
  {
    id: 71037,
    name: "Among Us: Surprise Egg",
    img: "/images/gm_among_us_surprise_egg.jpg",
    url: "https://html5.gamemonetize.com/84nm9eroyjz2xgikr5q27h2i326g95qh/",
    description:
      "It is a fun game for kids. You'll love this game with Among Us characters. Break the eggs and meet Among Us characters. Have fun!",
    category: ["Arcade"],
    tag: [
      "best",
      "boys",
      "clicker",
      "funny",
      "girls",
      "hot",
      "html",
      "hypercasual",
      "kids",
      "new",
    ],
    control_info: "Game Controls LEFT CLICK",
  },
  {
    id: 71262,
    name: "Puppy Blast: Journey of Crush",
    img: "/images/gm_puppy_blast_journey_of_crush.jpg",
    url: "https://html5.gamemonetize.com/gaykvre8wrs7eagyv357jj7trvgt40sl/",
    description:
      "Play Puppy Blast: Journey of Crush! Explore and solve thousands of addictive crush puzzles in the cartoon world! Match the cubes of the same color and combine boosters for huge explosions to blast your way through thousands of levels! Just to blast, Just to have fun!",
    category: ["Puzzles"],
    tag: [
      "action",
      "arcade",
      "boys",
      "candy",
      "girls",
      "jewel",
      "match 3",
      "matching",
      "puzzle",
    ],
    control_info: "Swipe with mouse",
  },
  {
    id: 71285,
    name: "Momo Pop",
    img: "/images/gm_momo_pop.jpg",
    url: "https://html5.gamemonetize.com/cqfw5c93fqef9pkp55e30darvb4i9l6m/",
    description:
      "Momo Pop is a match-3 game with cute characters with 100 fun yet challenging stages.",
    category: ["Puzzles"],
    tag: [
      "1 player",
      "2d",
      "animal",
      "arcade",
      "bejeweled",
      "boy",
      "boys",
      "casual",
      "cute",
      "game",
      "games",
      "girl",
      "girls",
      "html5",
      "hypercasual",
      "kid",
      "kids",
      "match 3",
      "match-3",
      "match3",
      "matching",
      "puzzle",
    ],
    control_info: "Swipe to move piece",
  },
  {
    id: 71310,
    name: "Design Dollhouse for Princess",
    img: "/images/gm_design_dollhouse_for_princess.jpg",
    url: "https://html5.gamemonetize.com/u4lrjiqoqe6z9l89irrnvqidt8bolsmf/",
    description:
      "Princess Nana bought a new duplex house. How to decorate and dress it? Come and try it and see if you can design a duplex room that you like!",
    category: ["Puzzles"],
    tag: ["2d", "dress up", "girl", "girls", "princess"],
    control_info: "click",
  },
  {
    id: 71464,
    name: "Delicious Smoothie Maker",
    img: "/images/gm_delicious_smoothie_maker.jpg",
    url: "https://html5.gamemonetize.com/vy0qgehgmrl2lvf3ggy2tx4i3z3dfmma/",
    description:
      "Welcome to our smoothies empire, where you can make the best smoothies! Once your smoothies is done, use our decorating stuff that can turn smoothies into tasty and yummy desserts! Do the same thing with a smoothies cups u2013 decorate them with different straws and stickers. Make smoothies look lovable. Isnu2019t this one of the best desserts games ever or what?!",
    category: ["Action"],
    tag: ["cooking", "girls"],
    control_info: "Use mouse to play the game ",
  },
  {
    id: 72022,
    name: "Jump Dude",
    img: "/images/gm_jump_dude.jpg",
    url: "https://html5.gamemonetize.com/64ww2mai4dmgrr7rucht3xqt2a4r6esd/",
    description:
      "Fly high in Jetpack Jump! Reach new places and destinations waiting to be discovered! Explore the world, with nothing but the jetpack on your back. Start at the track field, making sure you time your tap right to hop, skip and JUMP, soaring into the atmosphere. As you soar across the sky make sure you use all your jetpack fuel to go the distance and enjoy the full joyride through the sky. Coming down to earth with a bump, will you be able to beat your previous best distance?",
    category: ["Action"],
    tag: ["adventure", "boy", "girl", "girls", "jump"],
    control_info: "Please use mouse to handle the boy",
  },
  {
    id: 72187,
    name: "Pull Him Out Online",
    img: "/images/gm_pull_him_out_online.jpg",
    url: "https://html5.gamemonetize.com/mhqkw9a80at8pnqcc6jj2uiii5chfai1/",
    description:
      "The hunter begins his journey for treasure, but the puzzles in front of the hunter trapped him. What you need to do is to draw the stick in the right order, so that the hunter can take the hidden treasure away safely.",
    category: ["Puzzles"],
    tag: ["adventure", "boys", "girls", "logic", "logical", "puzzle"],
    control_info: "Use Mouse to Play",
  },
  {
    id: 72200,
    name: "Chicken Egg Challenge",
    img: "/images/gm_chicken_egg_challenge.jpg",
    url: "https://html5.gamemonetize.com/40gkg5vvla2wm4axibn51aa0ls8n3vn7/",
    description:
      "Are you ready for a fun competition with your friends? Before your friends fill your basket with 10 eggs. The first to fill his basket wins. Losing players have to make the bets! If you don't want to smell your friends' socks, don't want to eat onions, or don't want to do a chicken dance, press the button quickly! Have fun!",
    category: ["Action"],
    tag: [
      "1 player",
      "2 player",
      "2 player games",
      "2d",
      "animal",
      "best",
      "boy",
      "cartoon",
      "chicken",
      "click",
      "clicker",
      "crazy",
      "fun",
      "funny",
      "girl",
      "highscore",
    ],
    control_info:
      "1 Player J 2 Player W and Up Arrow 3 Player W J and Up Arrow You can play this game on mobile ",
  },
  {
    id: 72387,
    name: "Magic Academy",
    img: "/images/gm_magic_academy.jpg",
    url: "https://html5.gamemonetize.com/tariba688hnznd9pmqjv3e3j2yj47r50/",
    description:
      "Set up your own magic shop and make potions all day long until you become a real witch! Magic potion making in magical school games is not easy u2013 it requires concentration and a lot of skills",
    category: ["Action"],
    tag: [".io", "1 player", "3d", "adventure", "arcade", "dress up", "girls"],
    control_info: "Touch or mouse",
  },
  {
    id: 72530,
    name: "Angry Birds Jigsaw Puzzle Collection",
    img: "/images/gm_angry_birds_jigsaw_puzzle_collection.jpg",
    url: "https://html5.gamemonetize.com/xmfmjelurxoppbqrlg1zosltugg8nu8l/",
    description:
      'If you love the "Angry Birds" cartoon and are fond of folding puzzles, then this free online game invites you to indulge in your favorite hobby in the company of fairy tale characters. Angry Birds\' war with pigs does not stop even for a day. Enemies make any attempts to annoy each other. This time, the pigs took possession of a photo album of angry birds and tore their photos to pieces. Start the game and help the birds to restore them.',
    category: ["Puzzles"],
    tag: ["bird", "boys", "girls", "jigsaw"],
    control_info: "mouse",
  },
  {
    id: 72554,
    name: "Dora The Explorer Jigsaw Puzzle",
    img: "/images/gm_dora_the_explorer_jigsaw_puzzle.jpg",
    url: "https://html5.gamemonetize.com/s1biyzkdrv1jvh41fg2vq0ovfymhwhio/",
    description:
      "Dora the Explorer Jigsaw Puzzle is fun online game for kids and you can play it for free. Play this game in your browser or mobile device. Dora the Explorer never stops adventuring, and now her adventures have taken her into jigsaw puzzles! With this game, extra large, shaped floor puzzle even some of her littlest fans can join the fun. Have fun playing and come back for more.",
    category: ["Puzzles"],
    tag: [
      "android",
      "cartoon",
      "dora",
      "girls",
      "html5",
      "jigsaw",
      "mobile",
      "puzzle",
      "skill",
    ],
    control_info: "Mouse or tap to play ",
  },
  {
    id: 72556,
    name: "Foot Spa",
    img: "/images/gm_foot_spa.jpg",
    url: "https://html5.gamemonetize.com/lbis89q6h97a2hfjjl0q5i8ymg9w7fxt/",
    description:
      "Foot Spa is specially made for pampering baby girlu2019s love for dressing like her style freak mom. Although it is meant for kidu2019s play but if you have creative bend of mind and you love enjoying spa service this virtual beautification game will keep you engrossed on your mobile screen",
    category: ["Action"],
    tag: [".io", "1 player", "2d", "arcade", "dress up", "girl"],
    control_info: "Mouse or touch",
  },
  {
    id: 72640,
    name: "Pou Online",
    img: "/images/gm_pou_online.jpg",
    url: "https://html5.gamemonetize.com/jyeazqa0x7ym5xcq22g9mgv74s5tift1/",
    description:
      "Do you have what it takes to take care of your very own alien pet? Feed and take care of Pou.",
    category: ["Puzzles"],
    tag: ["boys", "girls", "html5"],
    control_info: "Mouse control",
  },
  {
    id: 72641,
    name: "Hero Rescue Puzzle",
    img: "/images/gm_hero_rescue_puzzle.jpg",
    url: "https://html5.gamemonetize.com/3596x93682lmj4cn7mrtldmfhviig7jj/",
    description:
      "Do you like rescue games? Of course, they are great. Help the hero rescue to save the princess and get the treasure in the new hero wars game - Hero Rescue. Shoot the sticks to save the princess, to kill the goblins, to get a treasure, ... You will become a rich hero in this township rescue game.",
    category: ["Puzzles"],
    tag: ["action", "boys", "fun", "girls", "html5", "logic", "puzzle"],
    control_info: "Mouse control",
  },
  {
    id: 73493,
    name: "Doodle Jump",
    img: "/images/gm_doodle_jump.jpg",
    url: "https://html5.gamemonetize.com/olb8b8mrvsa1ln4h0s5i210wnhf3kw38/",
    description:
      "Doodle Jump is a fun and cute platform game in which your must help our adorable doodle character jump as high as possible onto a range of different hand-drawn platforms. This game is an endless game, so you must simply keep jumping and try to register as high a score as you possibly can! Your character jump automatically, you must control their left and right movement - use the left and right arrow keys to move your character and alter their jumping position. As you progress you will notice a variety of different platforms - the brown platforms break after being touched for example, and some green platforms have springs on to boost you further! Watch out for the nasty bugs too that will try and harm you! How far can you jump in Doodle Jump?",
    category: ["Action"],
    tag: ["2d", "action", "boy", "clicker", "girl", "jump", "jumping", "sky"],
    control_info: "Mouse and keyboard",
  },
  {
    id: 73527,
    name: "Talking Tom Makeovert",
    img: "/images/gm_talking_tom_makeover.jpg",
    url: "https://html5.gamemonetize.com/qvy8l1r5trj9jflp0km9wwsxzlyc35ct/",
    description:
      "In this baby Talking Tom makeover game you will be the one in charge of making him look handsome. You will need to figure out what best suits him at this young age and pick out the best looking and the cutest clothes that you can find. The cool thing is that you can change pretty much everything about him and this way you will make him look really awesome. Try out all the items and do not forget under any circumstances about the accessories as they are often the ones that make or break a new look. Nobody will think a plain outfit is really cool without some nice accessories, especially for someone that is as cute and famous as Talking Tom.",
    category: ["Action"],
    tag: ["girl", "girls"],
    control_info: "MOUSE",
  },
  {
    id: 73541,
    name: "Owl Styles Jigsaw",
    img: "/images/gm_owl_styles_jigsaw.jpg",
    url: "https://html5.gamemonetize.com/b4nwztgpg33iwc3ruubrr3cd01k7al7m/",
    description:
      "Owl Styles Jigsaw game is free online game in jigsaw puzzle genre. You have 6 images in three modes to play. Choose one of the modes for the game that you previous choose and start it to play. Drag and drop the pieces to solve the puzzle and create an image. Enjoy, and have fun!",
    category: ["Puzzles"],
    tag: ["bird", "girls", "html5", "jigsaw", "kids", "mobile", "puzzle"],
    control_info: "Use mouse to play this game ",
  },
  {
    id: 73765,
    name: "Talking Tom  Angela Great Manicuret",
    img: "/images/gm_talking_tom_angela_great_manicure.jpg",
    url: "https://html5.gamemonetize.com/py85xrfkrw1oi9t3ex1u32saked1yy1n/",
    description:
      "Cats are cute as is but in this baby Talking Angela manicure game you will see that the cuteness will be brought to a whole new level by giving her a nice set of nails. She really loves different colors so why not use plenty of them and do not forget about some cute ornaments that go on top of them. This is how you will make her look amazing and you can explore your artistic side. Let us see how well you can handle so many choices and make her pretty little paws look great so she will be ready to take plenty of photos to show off to her friends. Be ready for more customers in this nail salon game as they will be coming in hot when they know you did ...",
    category: ["Action"],
    tag: ["girl", "girls"],
    control_info: "MOUSE",
  },
  {
    id: 73832,
    name: "Burger Shop Fast Food",
    img: "/images/gm_burger_shop_fast_food.jpg",
    url: "https://html5.gamemonetize.com/2s7yge9f6xerxrjoto47f9x0ye33nn3q/",
    description:
      "Burger shop is a management game where you have to serve your customer and give them when they are asking, category:Restaurant Serving",
    category: ["Action"],
    tag: [".io", ".io games", "cook", "cooking", "girl", "girls"],
    control_info: "Mouse",
  },
  {
    id: 73893,
    name: "Almond coconut caket",
    img: "/images/gm_almond_coconut_cake.jpg",
    url: "https://html5.gamemonetize.com/s3sz2oow2i4iyzsm0yj5eti550jjl7jd/",
    description:
      "A wonderful Christmas carol is coming home to celebrate the Merry Christmas. Some special and a different taste cake have to be prepared . Aanya plan to make a sweet Almond Coconut cake. She needs your partnership to make a delicious cake. As she have a short time to make a cake, Aanya wants you to be with her till she complete the cake for the carols. Have a Happy Christmas. category:Cake",
    category: ["Action"],
    tag: ["cooking", "girl"],
    control_info: "Mouse",
  },
  {
    id: 73894,
    name: "Authentic Spanish Paella",
    img: "/images/gm_authentic_spanish_paella.jpg",
    url: "https://html5.gamemonetize.com/gkfj3nnn1icx8ah143lk5a08k1vlvslc/",
    description:
      "Cook a delicious spanish paella for your family. This game will give you a little lesson to show you how to do a good spanish paella. category:BakingKitchen",
    category: ["Action"],
    tag: ["cook", "cooking", "girl", "girls"],
    control_info: "MOUSE",
  },
  {
    id: 73922,
    name: "Funny Little Kittens",
    img: "/images/gm_funny_little_kittens.jpg",
    url: "https://html5.gamemonetize.com/zs3a9kj8pfui1ley2lqo5iots33f8z17/",
    description:
      "Funny Little Kittens game is free online game in jigsaw puzzle genre. You have 6 images in three modes to play. Choose one of the modes for the game that you previous choose and start it to play. Drag and drop the pieces to solve the puzzle and create an image. Enjoy, and have fun!",
    category: ["Puzzles"],
    tag: [
      "cat",
      "funny",
      "girls",
      "html5",
      "jigsaw",
      "kids",
      "mobile",
      "puzzle",
    ],
    control_info: "Use mouse to play this game ",
  },
  {
    id: 74234,
    name: "The Powerpuff Girls Differences",
    img: "/images/gm_the_powerpuff_girls_differences.jpg",
    url: "https://html5.gamemonetize.com/mj88yz2a8wwggtlm7he8jkh11oe25icr/",
    description:
      "Now it's time to take a look at some pictures with Powerpuff Girls. Behind these pictures are small differences. Can you find them? They are fun designs for you to play with. A game that is fun and educational because it will help you improve your observation and concentration skills. You have 10 levels and 7 differences, for each level you have one minute to finish the same. Have fun!",
    category: ["Puzzles"],
    tag: [
      "cartoon",
      "cartoon network",
      "difference",
      "fun",
      "girls",
      "html5",
      "kids",
      "mobile",
      "skill",
    ],
    control_info: "Use mouse or touch the screen ",
  },
  {
    id: 74256,
    name: "Dora Spot The Difference",
    img: "/images/gm_dora_spot_the_difference.jpg",
    url: "https://html5.gamemonetize.com/upozzn7cnqqpllfqgguyj4z72wyp3e1y/",
    description:
      "Come on, let's find a differences between two images. Thus, our cute Dora will be very happy. Good luck and have fun!",
    category: ["Action"],
    tag: [
      "android",
      "cartoon",
      "dora",
      "fun",
      "girls",
      "html5",
      "hypercasual",
      "kids",
      "mobile",
      "school",
      "skill",
    ],
    control_info: "Mouse or tap to play ",
  },
  {
    id: 74857,
    name: "ZigZag Taxi ",
    img: "/images/gm_zigzag_taxi.jpg",
    url: "https://html5.gamemonetize.com/8yjtkpfthixeff4ne8puuu2h39t1joes/",
    description:
      "Build roads and get the taxi to the ending platform! This simple, addicting, 1 touch casual game will keep you distracted for hours. Over 100 levels of addicting gameplay! Tap & hold your screen to build bridges for the taxi to ride on! The perfect tap timing is key.",
    category: ["Arcade"],
    tag: ["boys", "girls", "taxi"],
    control_info: "Use mouse to play ",
  },
  {
    id: 74932,
    name: "Hello Kitty Spot the Difference",
    img: "/images/gm_hello_kitty_spot_the_difference.jpg",
    url: "https://html5.gamemonetize.com/2g36f17o4ctw5rcxsimvw3w1gmauqaxt/",
    description:
      "Hello Kitty Spot the Differences - Welcome to the Unforgettable 'Spot the Difference' game! Test your powers of observation and see if you can find all the differences in this funny online game for kids.",
    category: ["Action"],
    tag: [
      "arcade",
      "boys",
      "difference",
      "fun",
      "girls",
      "hello kitty",
      "html5",
      "kids",
      "mobile",
      "puzzle",
    ],
    control_info: "Mouse or tap to play ",
  },
  {
    id: 75056,
    name: "Kingdom Rush",
    img: "/images/gm_kingdom_rush.jpg",
    url: "https://html5.gamemonetize.com/t91chr038hb5zdwidh6203bhk4kzc5k6/",
    description:
      "The kingdom is under attack! Defend your realm against hordes of orcs, trolls, evil wizards and other nasty fiends; armed with a mighty arsenal of warriors and mages of your own!",
    category: ["Arcade"],
    tag: ["2d", "boys", "girls", "tower defense"],
    control_info: "Use mouse to play ",
  },
  {
    id: 75700,
    name: "Cartoon Dinosaur Memory Challenge",
    img: "/images/gm_cartoon_dinosaur_memory_challenge.jpg",
    url: "https://html5.gamemonetize.com/yseo06703anod1gwpy54jujim6sz6uz5/",
    description:
      "Play Cartoon Dinosaur Memory Challenge for free online! Turn over two cards and try to find the matching pairs of cards. Can you match up all the dinos? Have fun playing.",
    category: ["Puzzles"],
    tag: [
      "android",
      "boys",
      "fun",
      "girls",
      "html5",
      "kids",
      "memory",
      "school",
      "skill",
    ],
    control_info: "Mouse or tap to play ",
  },
  {
    id: 75743,
    name: "House Cleaning",
    img: "/images/gm_house_cleaning.jpg",
    url: "https://html5.gamemonetize.com/6wodqlw5ta6tvf0zl62bcgppeu2g8e9f/",
    description:
      "You have a beautiful baby doll house to clean with many rooms where all the things are spread everywhere, grab some cleaning tools and do you job by making a clean house where everything shines.",
    category: ["Action"],
    tag: ["cleaning", "cute", "girls"],
    control_info: " Use mouse to play",
  },
  {
    id: 75769,
    name: "Top Burger Chef",
    img: "/images/gm_top_burger_chef.jpg",
    url: "https://html5.gamemonetize.com/k8ktjke6tx2xm9ho9catx17yub9tt5ie/",
    description:
      "Top Burger Cooking is a classic arcade game where you have to serve the customers in a perfect manner. Be careful about what they want and prepare the exact same food. Collect the money and level up! Enjoy!",
    category: ["Action"],
    tag: ["cooking", "girls", "restaurant"],
    control_info: "Use mouse to play",
  },
  {
    id: 76020,
    name: "Zooba Fun Differences",
    img: "/images/gm_zooba_fun_differences.jpg",
    url: "https://html5.gamemonetize.com/3x771tqmx1ozctcplgyti6ud84m1xlv0/",
    description:
      "The Zooba famous game is here once again. Take a look at the two pictures in each level that feature Zooba characters. They may seem identical, but theyu2019re not! Youu2019ll need to find the five differences in each challenging level while you play this funny cartoon html5 game.",
    category: ["Puzzles"],
    tag: [
      "android",
      "boys",
      "cartoon",
      "collecting",
      "difference",
      "girls",
      "html5",
    ],
    control_info: "Mouse or tap to play ",
  },
  {
    id: 76123,
    name: "volumetric wood",
    img: "/images/gm_volumetric_wood.jpg",
    url: "https://html5.gamemonetize.com/96prafh638o904lk5p777ev13qrivg84/",
    description: "Help blocks of the same color come together, it's up to you",
    category: ["Puzzles"],
    tag: ["2d", "girl"],
    control_info: "mouse",
  },
  {
    id: 76127,
    name: "Ben 10 Puzzle Challenge",
    img: "/images/gm_ben_10_puzzle_challenge.jpg",
    url: "https://html5.gamemonetize.com/6siylrsnvqldb73s2a7kwlhj1hvn84if/",
    description:
      "Ben 10 Puzzle Challenge is an online game that you can play for free. Ben 10 Puzzle Challenge. Drag the pieces into right position using mouse or finger. You can choose one of four modes: easy, medium, expert. Have a good time!",
    category: ["Puzzles"],
    tag: [
      "arcade",
      "ben 10",
      "boys",
      "cartoon",
      "fun",
      "girls",
      "jigsaw",
      "kids",
      "puzzle",
      "school",
    ],
    control_info: "Mouse or tap to play ",
  },
  {
    id: 76138,
    name: "Block Puzzle Star",
    img: "/images/gm_block_puzzle_star.jpg",
    url: "https://html5.gamemonetize.com/ai2f44hil8mf7u5b8411dm83s1dyfhbp/",
    description:
      "Click on 3 or more connected stars of the same color to eliminate the stars and get a star bomb under certain conditions.",
    category: ["Puzzles"],
    tag: ["1 player", "2d", "bomb", "girl", "jewel"],
    control_info: "mouse",
  },
  {
    id: 76290,
    name: "Tennis Championship",
    img: "/images/gm_tennis_championship.jpg",
    url: "https://html5.gamemonetize.com/kf4yksc266yafcdl02xoxwiq71gf6fbr/",
    description:
      "Mini Tennis 3D is a mouse-controlled tennis game with a tournament-style competition. If you donu2019t want to deal with any settings, you can simply start playing right away. Your objective will be to win every match!",
    category: ["Sports"],
    tag: [
      "block",
      "boys",
      "fun",
      "girls",
      "minecraft",
      "sports",
      "tennis",
      "webgl",
    ],
    control_info: "Use mouse to play",
  },
  {
    id: 76441,
    name: "Merge & Hit  Knives",
    img: "/images/gm_merge_hit_knives.jpg",
    url: "https://html5.gamemonetize.com/mjj2vo5nkjgd2uakxqljiot530945o8r/",
    description:
      "Merge & Hit Knives is a mix of two famous games: Merge and Knife Hit. Start with a simple knife, merge the similar knives to unlock new and better weapon. Keep doing so to unlock exciting fantasy weapons, swords, daggers and much more. Gain experience and challenge yourself. When you will be readu try to hit knifes game and complete all levels.",
    category: ["Arcade"],
    tag: [
      "boys",
      "endless",
      "fun",
      "funny",
      "girls",
      "html5",
      "kids",
      "mobile",
      "weapons",
    ],
    control_info: "Use mouse to play ",
  },
  {
    id: 76614,
    name: "Dig Water Puzzle",
    img: "/images/gm_dig_water_puzzle.jpg",
    url: "https://html5.gamemonetize.com/tg2fdi08st1du8qfondcf8kqqpj6dom6/",
    description:
      "Dig Water is very simple but at the same time very exciting. Just dig sand and flow water to rescue the burning palnts. Dig sand u2013 flow water and rescue.",
    category: ["Puzzles"],
    tag: ["boy", "boys", "fun", "funny", "girl", "girls", "kids", "mobile"],
    control_info: "Use mouse to play ",
  },
  {
    id: 76515,
    name: "Tangram King",
    img: "/images/gm_tangram_king.jpg",
    url: "https://html5.gamemonetize.com/42pektghaixaurm5cw46mzbh7xyito5x/",
    description:
      "The Tangram King is a dissection puzzle consisting of seven flat shapes, called tans, which are put together to form shapes. The objective of the puzzle is to form a specific shape (given only an outline or silhouette) using all seven pieces, which may not overlap. It is reputed to have been invented in China during the Song Dynasty, and then carried over to Europe by trading ships in the early 19th century.",
    category: ["Puzzles"],
    tag: ["boys", "girls", "html5", "kids", "king", "mobile"],
    control_info: "Use mouse to play ",
  },
  {
    id: 76596,
    name: "Roller Smash",
    img: "/images/gm_roller_smash.jpg",
    url: "https://html5.gamemonetize.com/5dsyfrwsvassqhrblq3n3ox8uvl2co5i/",
    description:
      "Roll the magnet ball through the level, but what if you can destruct everything by the magnetic force of the ball! Simple controls but hard to master. Avoid the bad stuff and try your best to collect all the cubes!",
    category: ["Arcade"],
    tag: [
      "3d",
      "3d games",
      "ball",
      "boys",
      "girls",
      "kids",
      "mobile",
      "skill",
      "skills",
    ],
    control_info: "Use mouse or Arrows to play ",
  },
  {
    id: 76597,
    name: "Domino Falls 3D",
    img: "/images/gm_domino_falls_3d.jpg",
    url: "https://html5.gamemonetize.com/o6x9uwvs5wsz47197ed39zkfd51q71gv/",
    description:
      "You will be saved from pressure by the magical domino effect. Aim at one domino and shot it to strike all down! Challenge different levels and see what surprise are waiting for you after the dominos fall.",
    category: ["Arcade"],
    tag: [
      "3d games",
      "ball",
      "boys",
      "fun",
      "girls",
      "kids",
      "mobile",
      "puzzle",
    ],
    control_info: "Use mouse to play ",
  },
  {
    id: 77495,
    name: "Temple Run Tomb",
    img: "/images/gm_temple_run_tomb.jpg",
    url: "https://html5.gamemonetize.com/dlnobuyrrwc6y2x6uq86c6xp2esa1vwe/",
    description: "Best running game in mysterious temple.",
    category: ["Puzzles"],
    tag: [
      "action",
      "adventure",
      "arcade",
      "boys",
      "girls",
      "html5",
      "run",
      "running",
    ],
    control_info: "Mouse",
  },
  {
    id: 77170,
    name: "Ben10 Jumping Challenge",
    img: "/images/gm_ben10_jumping_challenge.jpg",
    url: "https://html5.gamemonetize.com/0zi1b4fgv4h27h1yspn1dshbz8d12wu3/",
    description:
      "Ben 10 Endless Jumping is an online game that you can play for free. Ben 10 Jumping Challenge is an arcade online game suitable for all ages. Help our cool Ben 10 jump as high as possible and make a high score. Collect gold coins and avoid hitting airplanes and helicopters. If you jump on them you will lose your health. Have fun playing.",
    category: ["Action"],
    tag: [
      "android",
      "arcade",
      "avoid",
      "ben 10",
      "boys",
      "cartoon",
      "collecting",
      "girls",
      "html5",
      "hypercasual",
      "jumping",
      "kids",
      "skill",
    ],
    control_info: "Mouse arrow keys or tap to play ",
  },
  {
    id: 77509,
    name: "Nyan Cat Flappy",
    img: "/images/gm_nyan_cat_flappy.jpg",
    url: "https://html5.gamemonetize.com/p2plk8zctrp4laba4sze0xtgiir8vmck/",
    description:
      "Do you think that only a bird can flap it's wings and fly? Ask Nyan Cat for the answer in her newest adventure in Flappy Nyan!",
    category: ["Arcade"],
    tag: ["boy", "fly", "fun", "funny", "girl", "jumping", "run"],
    control_info: "Controls Mouse",
  },
  {
    id: 52333,
    name: "Witch Alchemist Saga",
    img: "/images/gd_witch_alchemist_saga.jpeg",
    url: "https://html5.gamedistribution.com/e6d7246f4100424eb219b822e73bca9e/",
    description:
      "Solve magic puzzles, unlock brain puzzling levels and enjoy hours of fun in this highly addictive match 3 game! PLAY FOR FREE and challenge your brain now!",
    category: ["Hypercasual", "Puzzle"],
    tag: [
      "witchcraft",
      "puzzle",
      "candyland",
      "candies",
      "schoolgirl",
      "puzzles",
      "girlgames",
      "candy",
      "girlsdressup",
      "witch",
      "halloween",
    ],
    control_info: "Swipe to match candies",
  },
  {
    id: 52334,
    name: "Princess Halloween Makeup HalfFaces Tutorial",
    img: "/images/gd_princess_halloween_makeup_halffaces_tutorial.jpeg",
    url: "https://html5.gamedistribution.com/1bfad436efb74d43a20ecc817c4f6e43/",
    description:
      "Princess Harlequin, Snow White and Tropical Princess decided to surprise their friends on Halloween. The girls chose an unusual make-up. The left and right halves of the face depict different characters. The princesses invite you to their Halloween double makeup workshop. Find out the secrets of the best fabulous makeup artists and make a splash at the holiday.",
    category: ["Girls"],
    tag: ["girls", "girl", "makeup", "princess", "make-up", "halloween"],
    control_info: "Left mouse button or touch.",
  },
  {
    id: 58597,
    name: "Insect Cush",
    img: "/images/gd_insect_cush.jpeg",
    url: "https://html5.gamedistribution.com/75589825153d4bcb8fe9d98819048a4e/",
    description:
      "Are you looking for a game where you can have fun? Insect Cush game is for you. Clean up butterflies, ladybugs, ants and other pests.nInsect Cush has never been so much fun with its beautiful design and physics.nWith 56 different levels you will not understand how time passes. Moreover, now supported by fun animations.nRemember that you must hunt different pests in each section.",
    category: ["Shooting"],
    tag: [
      "girl",
      "trending",
      "casual",
      "bubble",
      "pet",
      "fun",
      "animal",
      "butterfly",
      "hypercasual",
      "girls",
      "2d",
      "funny",
      "html5games",
      "animals",
      "kid",
      "blast",
      "html5",
      "monster",
      "game",
      "mobile",
      "kids",
      "bubbleshooter",
      "candy",
      "fantasy",
      "pets",
      "halloween",
    ],
    control_info:
      "And very easy to play Insect Cush. You can start massacre with only mouse movements.",
  },
  {
    id: 69218,
    name: "Spider Among Us",
    img: "/images/gm_spider_among_us.jpg",
    url: "https://html5.gamemonetize.com/k8y4qpia4n9cufdi5tt0d3yxsrs2435p/",
    description:
      "Spider Among Us online is offline multiplayer game in which you are imposter and have to kill all of your crewmates without being notice. Use vent system, sabotage system or make custom setting in game to give yourself more challenge.",
    category: ["Driving"],
    tag: [
      "action",
      "adventure",
      "boys",
      "cartoon",
      "cartoon network",
      "girls",
      "puzzle",
      "spiderman",
      "sports",
    ],
    control_info:
      "Use on screen key controller on Mobile devices and directional keys on Computers ",
  },
  {
    id: 69220,
    name: "Princess Messy House Cleaning",
    img: "/images/gm_princess_messy_house_cleaning.jpg",
    url: "https://html5.gamemonetize.com/pnwpqajaultfbk4t8782r58wfli8vtkk/",
    description:
      "Welcome to Princess Messy House Cleaning : Girls Activities.A cute little princess is at home, there was a party in house, She decided to mange the Princess house cleaning.Everything is messy and dirty, need to make everything perfect as it was before the party. Clean up the kitchen, tidy up the stinky bathroom, wash the dishes, fix and design your dream playground! Renovate and decorate rooms in this house mansion! Take care of this dream home by cleaning and decorating it. Ever wanted to be a princess and live in a beautiful castle?Your dream comes true with My Princess Castle Cleaning for Girls! The Best Home Cleanup Game in 2021.House becomes a home when we spend our weekend in proper cleaning & washing.u2028 Now head towards to bedroom, put cloth in basket.Use broom to clean floor and window.Go to the garden and remove dirty plants.Use seeds and spray some water to plant a new tree.clean messy bathroom.Turn of the tap.Arrange soap and toys in bathroom to their place, and clean wash basin with brush.Put dirty toilet paper in dustbin.Wash toilet with liquid, rub with cotton and then wash with brush.Empty bathtub and clean it with brush. Game features u2028u2028 - Lot of room cleaning activities u2028- Step by step cleaningu2028 - Lot of cleaning tools u2028- Princess Tea Party u2028- Princess Unicorn Care u2028- Indian Home Cleaningu2028 - Cleaning Game For Girls - Mummy Rome Cleaningu2028 - Fun Word Gamesu2028 - Room Cleaning u2028- Home Makeoveru2028 - Girls House Cleaning u2028- My House Cleanupu2028 In-House Cleaning Day, clean up your house and get rid of the things which you donu2019t need. First, clean up all the rooms of your house from the kitchen to the bedroom and lastly your fish aquarium. Wipe up dust, vacuum the floors, and throw away junk! Leave nothing dirty and fix anything thatu2019s broken.The best cleaning game of all times is here! Build and renovate your dream castle! What are you waiting for? Itu2019s free to play. Download Messy House Cleaning : Girls Cleaning Activities Game for free on your smart phones.u2028Any Suggestion, Questions and Technical Support to improve this game is always welcome in this regard. u2028",
    category: ["Sports"],
    tag: ["cleaning", "girls", "house", "princess"],
    control_info:
      "Welcome to Princess Messy House Cleaning Girls Activities A cute little princess is at home there was a party in house She decided to mange the Princess house cleaning Everything is messy and dirty need to make everything perfect as it was before the",
  },
  {
    id: 66966,
    name: "Sofia Western Food Restaurant",
    img: "/images/yiv_Sofia-Western-Food-Restaurant.jpg",
    url: "https://www.yiv.com/games/Sofia-Western-Food-Restaurant/index.html",
    description:
      "Sofia opened a new western restaurant yesterday, Anna and her boyfriend Kristoff decide to try her new variety of dishes. Help Sofia make a dish of spaghetti and a plate of steak for them.",
    category: ["Girls"],
    tag: [
      "princess",
      "kids",
      "girls",
      "doll",
      "decorating",
      "cooking",
      "cartoon",
    ],
    control_info: "",
  },
  {
    id: 68727,
    name: "Crazy Fishing",
    img: "/images/yiv_Crazy-Fishing.jpg",
    url: "https://www.yiv.com/games/Crazy-Fishing/index.html",
    description:
      "Crazy Fishing is a html5 version of the mobile game Fishing Joy. Choose a net to catch fish, much fun, enjoy!",
    category: ["Girls", "Boys", "Shooting"],
    tag: ["shooting", "kids", "girls", "fun", "family", "boys", "animals"],
    control_info: "",
  },
  {
    id: 68526,
    name: "Candy Super Match3",
    img: "/images/yiv_Candy-Super-Match3.jpg",
    url: "https://www.yiv.com/games/Candy-Super-Match3/index.html",
    description:
      "Candy Super Match3 is a simple match 3 game, tap screen drag and drop the candy get high score.",
    category: ["Girls", "Boys", "Puzzle"],
    tag: ["puzzle", "matching", "kids", "highscore", "girls", "boys"],
    control_info: "",
  },
  {
    id: 66621,
    name: "Unicorn Slime Maker",
    img: "/images/yiv_Unicorn-Slime-Maker.jpg",
    url: "https://www.yiv.com/games/Unicorn-Slime-Maker/index.html",
    description:
      "Let us learn to make slime with simple and easy steps. Go to the supermarket and purchase all necessary items to make super satisfying Slime to release your stress and play with slime on your device. Release your stress, stretch slime, and squish it. Poking and stretching slime is my favorite activity. The poking slime is a very satisfying game.",
    category: ["Girls"],
    tag: [
      "unicorn",
      "simulation",
      "kids",
      "girls",
      "fun",
      "family",
      "doll",
      "decorating",
      "cute",
    ],
    control_info: "",
  },
  {
    id: 66617,
    name: "Nail Art",
    img: "/images/yiv_Nail-Art.jpg",
    url: "https://www.yiv.com/games/Nail-Art/index.html",
    description:
      "Hay, girls, here is a popular game about nail art. Choose a princess to design her nails. What paint will you choose? Which design? This nail salon simulator is the satisfying game youu2019ve been waiting for.",
    category: ["Girls"],
    tag: [
      "princess",
      "makeover",
      "kids",
      "girls",
      "fun",
      "doll",
      "decorating",
      "cute",
      "coloring",
      "cartoon",
    ],
    control_info: "",
  },
  {
    id: 66618,
    name: "Icing On Doll Cake",
    img: "/images/yiv_Icing-On-Doll-Cake.jpg",
    url: "https://www.yiv.com/games/Icing-On-Doll-Cake/index.html",
    description:
      "This game is a piece of cake! Relax and create beautiful dresses, full of style and fashion. The dress will spin and all you have to do is frost the outside with different colors. Put your dress styling skills to the test! Feel stress-free and channel your inner designer in this game.",
    category: ["Girls"],
    tag: [
      "princess",
      "kids",
      "girls",
      "fun",
      "family",
      "educational",
      "doll",
      "decorating",
      "cute",
      "cooking",
      "coloring",
      "cartoon",
    ],
    control_info: "",
  },
  {
    id: 66629,
    name: "Picnic With Cat Family",
    img: "/images/yiv_Picnic-With-Cat-Family.jpg",
    url: "https://www.yiv.com/games/Picnic-With-Cat-Family/index.html",
    description:
      "It's picnic time! Play games for four-year-old and older, take some food, and feed the cat! A lot of fun for girls and boys awaits you in this game for kids! Pick a cat and let's go!",
    category: ["Girls", "Puzzle"],
    tag: [
      "simulation",
      "puzzle",
      "kids",
      "girls",
      "fun",
      "family",
      "educational",
      "doll",
      "cute",
    ],
    control_info: "",
  },
  {
    id: 66634,
    name: "Mighty Christmas Jigsaw",
    img: "/images/yiv_Mighty-Christmas-Jigsaw.jpg",
    url: "https://www.yiv.com/games/Mighty-Christmas-Jigsaw/index.html",
    description:
      "The Mighty Express welcomes a new train and speeds into a snowstorm to deliver Santau2019s presents and save Christmas for all the kids in Tracksville. If you are interested in this cartoon, you can join us to have a try at the jigsaw. Hope you can have fun!",
    category: ["Girls", "Boys", "Puzzle"],
    tag: [
      "puzzle",
      "matching",
      "kids",
      "jigsaw",
      "girls",
      "fun",
      "educational",
      "doll",
      "cute",
      "christmas",
      "cartoon",
      "boys",
    ],
    control_info: "",
  },
  {
    id: 66637,
    name: "Robot Car Emergency Rescue 2",
    img: "/images/yiv_Robot-Car-Emergency-Rescue-2.jpg",
    url: "https://www.yiv.com/games/Robot-Car-Emergency-Rescue-2/index.html",
    description:
      "Join Robot cars and save the city playing these cool games for boys and girls. Kids Games for Boys and Girls! Put out the fire, find the cat, repair the building, and much more! A new Port has been opened recently, and there's a typhoon there!",
    category: ["Girls", "Boys", "Adventure"],
    tag: [
      "painting",
      "kids",
      "girls",
      "fun",
      "educational",
      "cartoon",
      "cars",
      "boys",
      "adventure",
    ],
    control_info: "",
  },
  {
    id: 66645,
    name: "Hatch Your Unicorn Idol",
    img: "/images/yiv_Hatch-Your-Unicorn-Idol.jpg",
    url: "https://www.yiv.com/games/Hatch-Your-Unicorn-Idol/index.html",
    description:
      "A sparkling mix of kids' favorite things: kawaii unicorns, virtual pet care, of course, tons of rainbows! Hatch pony to form the cutest music band ever! Each little pony has a unique style, but all of them love to sing and dance.",
    category: ["Girls"],
    tag: [
      "unicorn",
      "simulation",
      "kids",
      "girls",
      "fun",
      "educational",
      "doll",
      "cute",
      "cartoon",
      "animals",
    ],
    control_info: "",
  },
  {
    id: 66649,
    name: "Educational Games For Kids",
    img: "/images/yiv_Educational-Games-For-Kids.jpg",
    url: "https://www.yiv.com/games/Educational-Games-For-Kids/index.html",
    description:
      "Fun & educational toddler learning games that help pre-k kids to learn easily. These kids' games include connecting the dots & puzzle games for kids like jigsaw puzzles games. is a kind of fun and educational toddler learning games that help pre-k kids to learn easily. These kids' games include connecting the dots & puzzle games for kids like jigsaw puzzles games.",
    category: ["Girls", "Puzzle"],
    tag: [
      "simulation",
      "puzzle",
      "matching",
      "kids",
      "jigsaw",
      "girls",
      "fun",
      "family",
      "educational",
      "doll",
      "decorating",
      "cute",
    ],
    control_info: "",
  },
  {
    id: 66651,
    name: "Rainbow Ice Cream And Popsicles",
    img: "/images/yiv_Rainbow-Ice-Cream-And-Popsicles.jpg",
    url: "https://www.yiv.com/games/Rainbow-Ice-Cream-And-Popsicles/index.html",
    description:
      "Do you love Ice Cream Games, Popsicles, Ice Cream Bars, Ice Cream Sandwiches, and Other Frozen Desserts? Do you love Soft Serve Ice Cream & the Ice Cream Truck? Do you fancy Cooking Games with Dessert Food Recipes? Join us to enjoy the process!",
    category: ["Girls"],
    tag: [
      "simulation",
      "kids",
      "girls",
      "fun",
      "family",
      "educational",
      "doll",
      "decorating",
      "cute",
      "cooking",
    ],
    control_info: "",
  },
  {
    id: 66655,
    name: "Sweet Baby Girl Summer Fun",
    img: "/images/yiv_Sweet-Baby-Girl-Summer-Fun.jpg",
    url: "https://www.yiv.com/games/Sweet-Baby-Girl-Summer-Fun/index.html",
    description:
      "Play the best summer holiday games for girls and boys! Spend your summer at the beach near the ocean with Sweet Baby Girl and her friends. Here every day is a beach party! From animal care and ocean clean up to cooking and beauty makeover, these girls have many plans for this summer.",
    category: ["Girls"],
    tag: [
      "makeover",
      "kids",
      "girls",
      "fun",
      "family",
      "educational",
      "dress up",
      "doll",
      "decorating",
      "cute",
      "cooking",
      "animals",
    ],
    control_info: "",
  },
  {
    id: 66657,
    name: "Dental Care Game",
    img: "/images/yiv_Dental-Care-Game.jpg",
    url: "https://www.yiv.com/games/Dental-Care-Game/index.html",
    description:
      "Boys and girls welcome to the Dentist, Here you can not only turn yourself into a professional dentist but also diagnose and cure different patients, make it you're dreaming one! In the game, patients are not models who just open their mouths with a poker face, they are so vivid with laughers and tears!",
    category: ["Girls"],
    tag: [
      "surgery",
      "simulation",
      "kids",
      "girls",
      "family",
      "educational",
      "doll",
      "decorating",
      "cute",
      "animals",
    ],
    control_info: "",
  },
  {
    id: 66660,
    name: "The Cutest Squishy Pet",
    img: "/images/yiv_The-Cutest-Squishy-Pet.jpg",
    url: "https://www.yiv.com/games/The-Cutest-Squishy-Pet/index.html",
    description:
      "The cutest squishy pet is clean pets so sometimes they want to take a shower or go to the bathroom. Help them! Now, it's time to play a new mini-game for kids! Play soccer and win cool prizes!",
    category: ["Girls", "Puzzle"],
    tag: [
      "simulation",
      "puzzle",
      "makeover",
      "kids",
      "girls",
      "fun",
      "family",
      "educational",
      "doll",
      "cute",
      "cartoon",
      "animals",
    ],
    control_info: "",
  },
  {
    id: 66661,
    name: "Free Educational Games",
    img: "/images/yiv_Free-Educational-Games.jpg",
    url: "https://www.yiv.com/games/Free-Educational-Games/index.html",
    description:
      "Learning is joyful with Khan Academy Kids! Our award-winning app includes thousands of educational activities, books, songs, and games for toddlers, preschoolers, kindergarteners, and first graders. A cast of adorable characters guide children through lessons, and our adaptive learning path customizes their experience to help them master different skills.",
    category: ["Girls", "Boys", "Puzzle"],
    tag: [
      "puzzle",
      "kids",
      "girls",
      "fun",
      "family",
      "educational",
      "doll",
      "decorating",
      "cute",
      "cognitive",
      "cartoon",
      "boys",
      "animals",
    ],
    control_info: "",
  },
  {
    id: 66662,
    name: "Animal Ice Cream Shop",
    img: "/images/yiv_Animal-Ice-Cream-Shop.jpg",
    url: "https://www.yiv.com/games/Animal-Ice-Cream-Shop/index.html",
    description:
      "Summer is the most loved and hottest season. Children really love ice cream, popsicles, smoothies... in the summer - especially at the beach. Baby Pandau2019s Ice Cream Shop is now open in a beautiful seaside resort. Spend your summer at the beach with baby panda Miumiu and her friends. Manage your own ice cream shop and make your customers happy!",
    category: ["Girls"],
    tag: [
      "simulation",
      "kids",
      "girls",
      "fun",
      "family",
      "educational",
      "doll",
      "decorating",
      "cute",
      "cooking",
      "cartoon",
      "animals",
    ],
    control_info: "",
  },
  {
    id: 66666,
    name: "Princess Makeup Salon",
    img: "/images/yiv_Princess-Makeup-Salon.jpg",
    url: "https://www.yiv.com/games/Princess-Makeup-Salon/index.html",
    description:
      "Princess Makeup Salon is a Free girl's makeup game! Beautiful Princess is a fashion idol like usual. This time, you are the fashion maker! Dress the girl from head to toe in Fashion Party!",
    category: ["Girls"],
    tag: [
      "princess",
      "makeover",
      "make up",
      "kids",
      "girls",
      "fun",
      "dress up",
      "doll",
      "cute",
      "cartoon",
    ],
    control_info: "",
  },
  {
    id: 66669,
    name: "Coloring And Learn",
    img: "/images/yiv_Coloring-And-Learn.jpg",
    url: "https://www.yiv.com/games/Coloring-And-Learn/index.html",
    description:
      '"Coloring And Learn" is a realistic coloring game with more than 250 pages with educational content for all ages!."Free mode": now you can freely draw, doodle, color and unleash your imagination. "Glow coloring mode": Create magic doodle artwork with neon paint! Explore the wonderful world of color! The whole family, parents, and children will have hours of fun together! Can draw and coloring in the same way they do on paper using different tools. You can have fun coloring with your families or do coloring contests with them. The possibilities are endless.',
    category: ["Girls", "Boys", "Puzzle"],
    tag: [
      "puzzle",
      "painting",
      "kids",
      "girls",
      "fun",
      "family",
      "educational",
      "doll",
      "decorating",
      "cute",
      "boys",
      "coloring",
    ],
    control_info: "",
  },
  {
    id: 66670,
    name: "My Baby Unicorn Virtual Pony Pet",
    img: "/images/yiv_My-Baby-Unicorn-Virtual-Pony-Pet.jpg",
    url: "https://www.yiv.com/games/My-Baby-Unicorn-Virtual-Pony-Pet/index.html",
    description:
      "You got a gift a super cute virtual unicorn baby! Become the best horse and pony nanny with fun My Baby Unicorn pet care game for kids and toddlers, girls and boys! Hatch a colorful egg and take care of the cutest newborn unicorn with rainbow hair! Bathe, feed, potty train, dress up, sing to sleep, and play fun games with your tiny virtual pet friend! Decorate the baby unicornu2019s room with rainbow colors! Play My Baby Unicorn virtual pet care game for kids every day and watch your virtual pet pony grow!",
    category: ["Girls"],
    tag: [
      "unicorn",
      "simulation",
      "makeover",
      "kids",
      "girls",
      "fun",
      "family",
      "educational",
      "dress up",
      "doll",
      "decorating",
      "cute",
      "cooking",
      "cartoon",
      "animals",
    ],
    control_info: "",
  },
  {
    id: 66671,
    name: "Baking Pizza",
    img: "/images/yiv_Baking-Pizza.jpg",
    url: "https://www.yiv.com/games/Baking-Pizza/index.html",
    description:
      "Cooking a heart-shaped pizza will be a very nice surprise for your friends. You get to make your own sauce, grate cheese, cut vegetables, and serve up a delicious homemade pizza cooked by you! With just a little practice you will become as good as an authentic Italian chef and a pizza master!",
    category: ["Girls"],
    tag: [
      "simulation",
      "kids",
      "girls",
      "fun",
      "family",
      "educational",
      "doll",
      "decorating",
      "cooking",
    ],
    control_info: "",
  },
  {
    id: 66672,
    name: "Baby Color Crafts",
    img: "/images/yiv_Baby-Color-Crafts.jpg",
    url: "https://www.yiv.com/games/Baby-Color-Crafts/index.html",
    description:
      "Let's decorate the crystal ball! Start the machine and fill the crystal ball with sequins. Then put colored stickers on the crystal ball to make it more shining. How to decorate a shell necklace? Placing shells of the same color on both sides of the gem pendant, which will make the shell necklace even prettier!",
    category: ["Girls", "Puzzle"],
    tag: [
      "puzzle",
      "painting",
      "kids",
      "girls",
      "fun",
      "family",
      "educational",
      "doll",
      "decorating",
      "cute",
      "cartoon",
    ],
    control_info: "",
  },
  {
    id: 66676,
    name: "Cake Master Shop",
    img: "/images/yiv_Cake-Master-Shop.jpg",
    url: "https://www.yiv.com/games/Cake-Master-Shop/index.html",
    description:
      "We all like sweets and delicious cakes, which cake do you want to make today? Challenge levels and unlock more sweet cakes! Many ingredients for cake cooking. Put them into bowls, and blend it, the next step is bake. Pick some fresh fruits. Over 15 kitchen tools, help you to make sweet and yummy cakesrn",
    category: ["Girls"],
    tag: [
      "kids",
      "girls",
      "fun",
      "educational",
      "doll",
      "decorating",
      "cute",
      "cooking",
    ],
    control_info: "",
  },
  {
    id: 66677,
    name: "Baby Supermarket",
    img: "/images/yiv_Baby-Supermarket.jpg",
    url: "https://www.yiv.com/games/Baby-Supermarket/index.html",
    description:
      "Welcome to the biggest supermarket in the Town! Baby and Mommy Panda have to do the supermarket shopping today! Play together with friends and family, and help your favorite panda to do shopping in an animal's Supermarket.",
    category: ["Girls"],
    tag: [
      "simulation",
      "matching",
      "makeover",
      "make up",
      "kids",
      "girls",
      "fun",
      "family",
      "educational",
      "dress up",
      "doll",
      "decorating",
      "cute",
      "animals",
    ],
    control_info: "",
  },
  {
    id: 66680,
    name: "Miss Hollywood Vacation",
    img: "/images/yiv_Miss-Hollywood-Vacation.jpg",
    url: "https://www.yiv.com/games/Miss-Hollywood-Vacation/index.html",
    description:
      "After winning a dream getaway to visit a beautiful island resort, Miss Hollywood and another pet friend arrive at Paradise Cove. There is just one problem, the hotel is in shambles! By competing in island adventure challenges, the pets can win prizes to help it become the dream destination it used to be!",
    category: ["Girls"],
    tag: [
      "simulation",
      "puzzle",
      "kids",
      "girls",
      "fun",
      "educational",
      "doll",
      "decorating",
      "cute",
      "animals",
    ],
    control_info: "",
  },
  {
    id: 66681,
    name: "Pets Hair Salon",
    img: "/images/yiv_Pets-Hair-Salon.jpg",
    url: "https://www.yiv.com/games/Pets-Hair-Salon/index.html",
    description:
      "Lovely pets are sitting in front of a mirror and waiting for new, funky haircuts. Bears, cats, dogs, and rabbits want to be real movie stars at least for one day. Design creative hairstyles for your customers before the curtains close.",
    category: ["Girls"],
    tag: [
      "simulation",
      "kids",
      "girls",
      "fun",
      "educational",
      "dress up",
      "doll",
      "decorating",
      "cute",
      "animals",
    ],
    control_info: "",
  },
  {
    id: 66682,
    name: "Tailor Kids",
    img: "/images/yiv_Tailor-Kids.jpg",
    url: "https://www.yiv.com/games/Tailor-Kids/index.html",
    description:
      "Enter the world of fashion, style, and design by working in a proper salon of dressmaking. You can meet your customersu2019 needs there and improve their looks by stylish makeovers.",
    category: ["Girls", "Puzzle"],
    tag: [
      "puzzle",
      "kids",
      "girls",
      "fun",
      "educational",
      "dress up",
      "doll",
      "decorating",
      "cute",
      "avoid",
    ],
    control_info: "",
  },
  {
    id: 66683,
    name: "Lovely Virtual Dog",
    img: "/images/yiv_Lovely-Virtual-Dog.jpg",
    url: "https://www.yiv.com/games/Lovely-Virtual-Dog/index.html",
    description:
      "Let us introduce you Duddu, our new dog! He is a super nice dog who lives in a wonderful world full of fun and adventure. Become a part of Dudduu2019s everyday life and build a true friendship with your new virtual pet.",
    category: ["Girls", "Boys", "Puzzle", "Adventure"],
    tag: [
      "simulation",
      "puzzle",
      "makeover",
      "kids",
      "girls",
      "fun",
      "family",
      "educational",
      "dress up",
      "doll",
      "cute",
      "cooking",
      "brain",
      "boys",
      "animals",
      "adventure",
    ],
    control_info: "",
  },
  {
    id: 66692,
    name: "Happy Garden",
    img: "/images/yiv_Happy-Garden.jpg",
    url: "https://www.yiv.com/games/Happy-Garden/index.html",
    description:
      "Spring has finally sprung! Itu2019s time to enjoy the flowers, vegetables, and fruits. So go out and plant your favorite crops in the garden! Combine business with pleasure and train your gardening skills in different sections of your garden: Vegetable Garden, Flower Shop, Greenhouse, Orchard, and Garden Shed. Trade fresh goods and garden tools with customers in the marketplace and take good care of your garden.",
    category: ["Girls"],
    tag: [
      "kids",
      "girls",
      "fun",
      "family",
      "educational",
      "doll",
      "decorating",
      "cute",
    ],
    control_info: "",
  },
  {
    id: 66693,
    name: "Pretty Box Bakery Game",
    img: "/images/yiv_Pretty-Box-Bakery-Game.jpg",
    url: "https://www.yiv.com/games/Pretty-Box-Bakery-Game/index.html",
    description:
      "Hey, girls! How about holding a makeup cake baking salon party in the baking games? Every girl loves to buy makeup kit and wants to be a beauty influencer! Now makeup artist, letu2019s DIY your cosmetic kit in a sweet way u2013 make comfy cakes. Decorate beautiful girls' makeup cake with candies in the cooking games for girl!",
    category: ["Girls"],
    tag: [
      "kids",
      "girls",
      "fun",
      "educational",
      "doll",
      "decorating",
      "cute",
      "cooking",
    ],
    control_info: "",
  },
  {
    id: 66694,
    name: "Babysitter Day",
    img: "/images/yiv_Babysitter-Day.jpg",
    url: "https://www.yiv.com/games/Babysitter-Day/index.html",
    description:
      "Looking after a baby is not easy, but at the same time interesting and enjoyable. If your little fidget goes to kindergarten or school, our new game is just for him! After all, playing it - your child will be able to look at himself from the side. It will give an opportunity to play mother to find out what a real babysitter is doing and what really is caring for a baby!",
    category: ["Girls", "Puzzle"],
    tag: [
      "puzzle",
      "kids",
      "girls",
      "fun",
      "family",
      "educational",
      "doll",
      "cute",
      "cooking",
      "cars",
    ],
    control_info: "",
  },
  {
    id: 66695,
    name: "Monster Truck Repairing",
    img: "/images/yiv_Monster-Truck-Repairing.jpg",
    url: "https://www.yiv.com/games/Monster-Truck-Repairing/index.html",
    description:
      "All kids, boys, and girls, love games about cars. When they play such wonderful educational games for children, they necessarily represent themselves as the driver of the real machine, and it does not matter - these are small cars, or high-speed sports cars, this is car washing and car repair.",
    category: ["Girls", "Boys", "Puzzle"],
    tag: [
      "simulation",
      "puzzle",
      "painting",
      "kids",
      "girls",
      "fun",
      "decorating",
      "cars",
      "boys",
    ],
    control_info: "",
  },
  {
    id: 66696,
    name: "Kids Movie Night",
    img: "/images/yiv_Kids-Movie-Night.jpg",
    url: "https://www.yiv.com/games/Kids-Movie-Night/index.html",
    description:
      "What's better than going to the movies? Running your very own movie theater! Help customers find their seats, make delicious snacks, and so much more! You can even decorate your very own movie poster - name the movie, choose a theme & dress up the actors! Enter the movie poster competition & vote for your favorite posters! How will this movie night end? Buy a ticket to find out.",
    category: ["Girls", "Puzzle"],
    tag: [
      "puzzle",
      "kids",
      "girls",
      "fun",
      "family",
      "educational",
      "doll",
      "decorating",
      "cute",
    ],
    control_info: "",
  },
  {
    id: 66699,
    name: "My Cute Pet Friend",
    img: "/images/yiv_My-Cute-Pet-Friend.jpg",
    url: "https://www.yiv.com/games/My-Cute-Pet-Friend/index.html",
    description:
      "Take care of cute pet, tend to him, make sure he stays healthy, entertain him, dress him up, go on adventures together, and discover an amazing world!",
    category: ["Girls", "Puzzle"],
    tag: [
      "puzzle",
      "kids",
      "highscore",
      "girls",
      "fun",
      "family",
      "educational",
      "dress up",
      "doll",
      "decorating",
      "cute",
      "animals",
    ],
    control_info: "",
  },
  {
    id: 66700,
    name: "Cute Pet Friends",
    img: "/images/yiv_Cute-Pet-Friends.jpg",
    url: "https://www.yiv.com/games/Cute-Pet-Friends/index.html",
    description:
      "Play and take care of two sweet virtual pets: cat Kiki and dog Fifi. Give a bubble bath, shower, clean up, brush fur, polish nails and design the perfect outfits for your virtual pets. Build a house and design the sweetest home for them. A perfect game for kids who want to have a cat or a dog and love taking care of cute virtual pets!",
    category: ["Girls", "Puzzle"],
    tag: [
      "kids",
      "girls",
      "fun",
      "educational",
      "doll",
      "decorating",
      "cute",
      "animals",
    ],
    control_info: "",
  },
  {
    id: 66703,
    name: "Animal Auto Repair Shop",
    img: "/images/yiv_Animal-Auto-Repair-Shop.jpg",
    url: "https://www.yiv.com/games/Animal-Auto-Repair-Shop/index.html",
    description:
      "Be a skilled auto mechanic who assembles, paints, washes, and repairs cars! Learn about and drive different cars, role play, enjoy imaginative activities! Vroom, vroom! Your car's arrived! Let's get started!",
    category: ["Girls", "Puzzle"],
    tag: [
      "puzzle",
      "kids",
      "girls",
      "fun",
      "educational",
      "doll",
      "decorating",
      "cars",
      "animals",
    ],
    control_info: "",
  },
  {
    id: 66712,
    name: "Chef Kids",
    img: "/images/yiv_Chef-Kids.jpg",
    url: "https://www.yiv.com/games/Chef-Kids/index.html",
    description:
      "Time for you and your friends to become the best little chefs around! No adults are around and you kids are hungry u2013 you better prepare food, and fast! You guys are in charge u2013 cook and bake whatever yummy food you want, and have a food fight!",
    category: ["Girls"],
    tag: [
      "kids",
      "girls",
      "fun",
      "educational",
      "dress up",
      "doll",
      "decorating",
      "cute",
      "cooking",
    ],
    control_info: "",
  },
  {
    id: 66717,
    name: "Fairy Pony Caring Adventure",
    img: "/images/yiv_Fairy-Pony-Caring-Adventure.jpg",
    url: "https://www.yiv.com/games/Fairy-Pony-Caring-Adventure/index.html",
    description:
      "Fairy Princess trusts the magical caring of her unicorns, colts and the pony family to a complete horse farm with all you can think of: From simple farming levels to all kinds of fun riding, pony breeding, dash, park, rainbow hair salon, pony beauty adventure or any other wild farm exciting challenges!",
    category: ["Girls", "Adventure"],
    tag: [
      "simulation",
      "kids",
      "girls",
      "fun",
      "educational",
      "dress up",
      "doll",
      "decorating",
      "cute",
      "cartoon",
      "animals",
      "adventure",
    ],
    control_info: "",
  },
  {
    id: 66718,
    name: "Mad Dentist",
    img: "/images/yiv_Mad-Dentist.jpg",
    url: "https://www.yiv.com/games/Mad-Dentist/index.html",
    description:
      "Mad Dentist is the best dentist game ever made. In this dentist game your mission is to solve patient's teeth problem.You are a dentist. Strap your patients in dental chair, grab your drill and start. How mad is the dentist, you can come to try it!",
    category: ["Girls"],
    tag: [
      "surgery",
      "simulation",
      "kids",
      "girls",
      "fun",
      "educational",
      "doll",
      "decorating",
      "cute",
    ],
    control_info: "",
  },
  {
    id: 66735,
    name: "Strawberry Shortcake Sweet Shop",
    img: "/images/yiv_Strawberry-Shortcake-Sweet-Shop.jpg",
    url: "https://www.yiv.com/games/Strawberry-Shortcake-Sweet-Shop/index.html",
    description:
      "Strawberry Shortcake has invited all of her friends to try out her delicious sweets and needs YOUR help to make them. Be a dessert chef and create sweet recipes that you can make later at home!",
    category: ["Girls"],
    tag: [
      "simulation",
      "kids",
      "girls",
      "fun",
      "educational",
      "doll",
      "decorating",
      "cute",
      "cooking",
    ],
    control_info: "",
  },
  {
    id: 66739,
    name: "Candy Cake Maker",
    img: "/images/yiv_Candy-Cake-Maker.jpg",
    url: "https://www.yiv.com/games/Candy-Cake-Maker/index.html",
    description:
      "Candy cake anyone? We all love cake, but we don't like the mess that it makes, why not get all the fun of making the cake without having to clean afterward. In Candy Cake Maker you'll first have to make the dough, by adding all the ingredients in the right order like in a real recipe.",
    category: ["Girls"],
    tag: [
      "kids",
      "girls",
      "fun",
      "educational",
      "doll",
      "decorating",
      "cute",
      "cooking",
    ],
    control_info: "",
  },
  {
    id: 66741,
    name: "Doctor Pets",
    img: "/images/yiv_Doctor-Pets.jpg",
    url: "https://www.yiv.com/games/Doctor-Pets/index.html",
    description:
      "Doctor Pets brings you a great chance to make animals healthy and happy again. Nature is home for a playful motley crew of animals. Dogs, cats, rabbits, and monkeys are looking for your help in a forest pet hospital. They need a doctor's help and they need it right now!",
    category: ["Girls", "Puzzles"],
    tag: [
      "surgery",
      "simulation",
      "puzzle",
      "kids",
      "girls",
      "educational",
      "doll",
      "cute",
      "animals",
      "doctor",
    ],
    control_info: "",
  },
  {
    id: 66742,
    name: "My Boo Virtual Pet",
    img: "/images/yiv_My-Boo-Virtual-Pet.jpg",
    url: "https://www.yiv.com/games/My-Boo-Virtual-Pet/index.html",
    description:
      "Each Boo is like a real pet that needs lots of attention, and your task is to take care of it in the best way possible. Feed it, wash it, take care of its health, put it to sleep and play with your Boo - while you have lots of fun with over 20 thrilling mini games that will surely keep you entertained and your Boo happy as a puppy!",
    category: ["Girls"],
    tag: [
      "simulation",
      "kids",
      "girls",
      "fun",
      "family",
      "educational",
      "dress up",
      "doll",
      "decorating",
      "cute",
    ],
    control_info: "",
  },
  {
    id: 66781,
    name: "Puzzle Fuzzle",
    img: "/images/yiv_Puzzle-Fuzzle.jpg",
    url: "https://www.yiv.com/games/Puzzle-Fuzzle/index.html",
    description:
      "Puzzle Fuzzle is a fun matching puzzle game with the things we usually see in real normal life. It is required for you to confirm the diagram written in each level first, then pick up the diagrams you need and combine them together in the middle of the screen. When you meet confusing situations you are able to use hints in Puzzle Fuzzle!",
    category: ["Girls", "Boys", "Puzzles"],
    tag: [
      "puzzle",
      "kids",
      "girls",
      "educational",
      "cute",
      "brain",
      "boys",
      "arcade",
    ],
    control_info: "",
  },
  {
    id: 66905,
    name: "Sofia Care Her Pet Hamster",
    img: "/images/yiv_Sofia-Care-Her-Pet-Hamster.jpg",
    url: "https://www.yiv.com/games/Sofia-Care-Her-Pet-Hamster/index.html",
    description:
      "Sofia got a pet hamster recently. She loves the hamster so much, she wish this hamster can accompany her for her every day. But today this hamster gets sick, Sofia is very nervous. Can you help her to take care of her hamster and make her happy again?",
    category: ["Girls", "Boys"],
    tag: [
      "surgery",
      "princess",
      "kids",
      "girls",
      "dress up",
      "doll",
      "cute",
      "cartoon",
      "boys",
      "animals",
    ],
    control_info: "",
  },
  {
    id: 74001,
    name: "Merge Ships",
    img: "/images/gm_merge_ships.jpg",
    url: "https://html5.gamemonetize.com/tl4140q252r2drn4c1zsfx71d6ocnnig/",
    description:
      "Do you want to have a huge fleet sailing in the sea?Want to do business with many cities in the world?In the game Merge Ships, you will have this opportunity.",
    category: ["Arcade"],
    tag: ["boys", "girls"],
    control_info: "Use mouse to play ",
  },
  {
    id: 75780,
    name: "Mr Bow",
    img: "/images/gm_mr_bow.jpg",
    url: "https://html5.gamemonetize.com/sinzont82bnqz8a697g4biossp6wrfsk/",
    description:
      "Become the legendary archer master and destroy the evil enemy archers. Choose your bow and arrow and destroy the enemy stickman archers in this bow hunting game. Sharpen your archery target and shooting skills and become a champion. Enemy force is near! Pick up your bow and start shooting.",
    category: ["Fighting"],
    tag: ["bow", "boys", "girls", "kids", "stickman"],
    control_info: "use mouse to play ",
  },
  {
    id: 67170,
    name: "Test Your Superhero Lover",
    img: "/images/yiv_Test-Your-Superhero-Lover.jpg",
    url: "https://www.yiv.com/games/Test-Your-Superhero-Lover/index.html",
    description:
      "Do you have a favorite Superhero, superman or Iron man? Do you want to know the degree of understanding between you and him? Let's have a test! Who will be your destiny?",
    category: ["Girls"],
    tag: ["kids", "girls", "fun"],
    control_info: "",
  },
  {
    id: 67542,
    name: "Candy Blast",
    img: "/images/yiv_Candy-Blast.jpg",
    url: "https://www.yiv.com/games/Candy-Blast/index.html",
    description:
      "Candy Blast is a interesting addictive match3 game.You can use your free time to enjoy the fun of it.Swap adjacent candies, make the line of at least three candies of the same kind and remove them from the field.Call your friends and make a high scoreuff01",
    category: ["Girls", "Boys", "Puzzle"],
    tag: ["puzzle", "matching", "kids", "girls", "boys"],
    control_info: "",
  },
  {
    id: 67902,
    name: "Kids Puzzle",
    img: "/images/yiv_Kids-Puzzle.jpg",
    url: "https://www.yiv.com/games/Kids-Puzzle/index.html",
    description:
      "Kids Puzzle is a excellent game to help children improve their abilities and speed in solving problems. There are 6 amazing puzzles for kids to play with. Have fun with this amazing puzzle for kids of all ages.",
    category: ["Girls", "Boys", "Puzzle"],
    tag: ["puzzle", "matching", "kids", "girls", "boys", "animals"],
    control_info: "",
  },
  {
    id: 67957,
    name: "Candy Rush 2",
    img: "/images/yiv_Candy-Rush-2.jpg",
    url: "https://www.yiv.com/games/Candy-Rush-2/index.html",
    description:
      "Candy Rush 2 is landscape puzzle Match 3 game with colorful and beautiful graphics, collect three or more of the same candy. Enjoy!",
    category: ["Girls", "Boys", "Puzzle"],
    tag: [
      "timing",
      "puzzle",
      "matching",
      "kids",
      "highscore",
      "girls",
      "cute",
      "boys",
    ],
    control_info: "",
  },
  {
    id: 67977,
    name: "Candy Rush",
    img: "/images/yiv_Candy-Rush.jpg",
    url: "https://www.yiv.com/games/Candy-Rush/index.html",
    description:
      "Candy Rush is puzzle Html5 Match 3 game with colorful and beautiful graphics, collect three or more of the same candy. Enjoy!",
    category: ["Girls", "Puzzle"],
    tag: ["timing", "puzzle", "matching", "kids", "highscore", "girls", "cute"],
    control_info: "",
  },
  {
    id: 68107,
    name: "Cake Rush Slots",
    img: "/images/yiv_Cake-Rush-Slots.jpg",
    url: "https://www.yiv.com/games/Cake-Rush-Slots/index.html",
    description:
      "A new arcade game, slot machine game. Sweet cakes and food, nice and fun, try it!",
    category: ["Girls", "Boys", "Puzzle"],
    tag: [
      "simulation",
      "puzzle",
      "matching",
      "kids",
      "highscore",
      "girls",
      "fun",
      "cute",
      "boys",
      "arcade",
    ],
    control_info: "",
  },
  {
    id: 68138,
    name: "Shoe House Decor",
    img: "/images/yiv_Shoe-House-Decor.jpg",
    url: "https://www.yiv.com/games/Shoe-House-Decor/index.html",
    description: "Design and decorate a cute shoe house, have fun!",
    category: ["Girls", "Boys"],
    tag: [
      "simulation",
      "kids",
      "girls",
      "family",
      "decorating",
      "cute",
      "boys",
    ],
    control_info: "",
  },
  {
    id: 68158,
    name: "Spongebob Baby Caring",
    img: "/images/yiv_Spongebob-Baby-Caring.jpg",
    url: "https://www.yiv.com/games/Spongebob-Baby-Caring/index.html",
    description:
      "SpongeBob is very naughty, but he is so cute, many people like him. Now, he is a baby, you are a babysister, you job is to babysit him. Please feed him before he starts to cry, and give him  rub body lotion, change his diaper and then play with him. At last, dressing him up in cute baby outfits and booties. Have fun!",
    category: ["Girls"],
    tag: ["kids", "girls", "dress up", "doll", "cute", "cartoon", "spongebob"],
    control_info: "",
  },
  {
    id: 68160,
    name: "Patrick Baby Caring",
    img: "/images/yiv_Patrick-Baby-Caring.jpg",
    url: "https://www.yiv.com/games/Patrick-Baby-Caring/index.html",
    description:
      "Patrick, Spongebob's dear friend. In the game, he is a cute baby, you are a babysister, you job is to babysit him. Please feed him before he starts to cry, and give him  rub body lotion, change his diaper and then play with him. At last, dressing him up in cute baby outfits and booties. Have fun!",
    category: ["Girls"],
    tag: ["kids", "girls", "dress up", "doll", "cute", "cartoon"],
    control_info: "",
  },
];
